// extracted by mini-css-extract-plugin
export default {"card":"DY-z","carouselContainer":"EY-z","carouselContent":"FY-z"};